import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import { getRequest, postRequest, deleteRequest, putRequest } from 'utils/http'

//Get Users
export const getUsers = async (current, pageSize, searchQuery) => {
  return getRequest('users', {
    params: {
      current: current,
      pageSize: pageSize,
      searchQuery: searchQuery,
    },
  })
}

export const useGetUsers = (current, pageSize, searchQuery) => {
  return useQuery({
    queryKey: ['fetch-users', current, pageSize, searchQuery],
    queryFn: () => getUsers(current, pageSize, searchQuery),
  })
}

//Create User
export const createUser = async params => {
  return postRequest(`users`, params)
}

export const useCreateUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: params => createUser(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-users'])
    },
  })
}

//Update User
export const updateUser = async params => {
  return putRequest(`users/${params.id}`, params.updatedUserData)
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: params => updateUser(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-users'])
    },
  })
}

//Delete a User (Single Deletion Logic Restored)
export const deleteUser = async params => {
  // Expects a single ID: { id: 123 }
  return deleteRequest(`users/${params.id}`)
}

export const useDeleteUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    // Updated mutationFn to call deleteUser with the single ID
    mutationFn: params => deleteUser(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-users'])
    },
  })
}

